import { fetchProductCategoryList } from "api/ProductCategory";
import { useEffect, useState } from "react"

export interface ProductGroup {
    id: string; // Slug
    label: string;
    subs?: { id: string; label: string }[];
}

interface ProductGroupAccordionProps {
    data: ProductGroup[];
    setSelectedCategory?: (category: string | null) => void;
}

export default function ProductGroupAccordion({ data, setSelectedCategory }: ProductGroupAccordionProps) {
    const [PRODUCT_GROUPS, setPRODUCT_GROUPS] = useState<ProductGroup[]>(data)

    useEffect(() => {
        setPRODUCT_GROUPS(data)
    }, [data])

    const [accordionOpen, setAccordionOpen] = useState(true)
    const [activeId, setActiveId] = useState<string | null>(null)
    const [activeSubId, setActiveSubId] = useState<string | null>(null)

    const toggleAccordion = () => {
        setAccordionOpen(prev => !prev)
    }

    const toggleItem = (id: string): void => {
        if (activeId === id) {
            setActiveId(null);
            setActiveSubId(null);
            if (setSelectedCategory) setSelectedCategory(null);
        } else {
            setActiveId(id);
            setActiveSubId(null);
            if (setSelectedCategory) setSelectedCategory(id);
        }
    }

    const selectSubItem = (parentId: string, subId: string): void => {
        setActiveId(parentId);
        setActiveSubId(subId);
        if (setSelectedCategory) setSelectedCategory(subId);
    }


    return (
        <div className="MuiPaper-root MuiAccordion-root filter-product-accordion Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded lh-1-5">

            <button className="styles_accordionHeader__xUFrY" onClick={toggleAccordion}>
                <p>Nhóm sản phẩm</p>
                <span className={[accordionOpen ? "styles_buttonExpand__QQLBp styles_buttonExpanded__jSTHs" : "styles_buttonExpand__QQLBp"].join(" ")}>
                    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>
                </span>
            </button>

            {accordionOpen && (
                <div className="MuiCollapse-root MuiCollapse-entered" style={{ minHeight: "0px" }}>
                    <div className="MuiCollapse-wrapper">
                        <div className="MuiCollapse-wrapperInner">
                            <div role="region">
                                <div className="MuiAccordionDetails-root accordion-detail" style={{ display: "block" }}>
                                    <div className="styles_containerList__c3d5v styles_itemList__qvTM4">

                                        {PRODUCT_GROUPS.map(item => {
                                            const isActive = activeId === item.id;

                                            return (
                                                <div key={item.id} style={{ width: "100%" }}>
                                                    {/* MAIN ITEM */}
                                                    <button
                                                        className={[
                                                            "styles_item__rQ1Ka",
                                                            "styles_itemWithDropdown__58jnU",
                                                            isActive && "styles_activeItem__7Yk8F",
                                                        ].filter(Boolean).join(" ")}
                                                        onClick={() => {
                                                            toggleItem(item.id);
                                                            if (setSelectedCategory) {
                                                                if (isActive) {
                                                                    setSelectedCategory(null);
                                                                } else {
                                                                    setSelectedCategory(item.id);
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <span>{item.label}</span>

                                                        
                                                    </button>

                                                    {/* SUB ITEMS */}
                                                    {isActive && item.subs && item.subs.length > 0 && (
                                                        <div className="styles_subEffWrapper__1f7Dz">
                                                            {item.subs.map(sub => (
                                                                <button
                                                                    key={sub.id}
                                                                    className={[
                                                                        "styles_subEffItem__xE1nQ",
                                                                        activeSubId === sub.id && "styles_activeItem__7Yk8F"
                                                                    ].filter(Boolean).join(" ")}
                                                                    onClick={() => selectSubItem(item.id, sub.id)}
                                                                >
                                                                    <span>{sub.label}</span>
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}
